export const RANK_CHART_PRINT_PAPERS = {
  letter: {
    id: 'letter',
    label: 'Letter',
  },
  a4: {
    id: 'a4',
    label: 'A4',
  },
};

export const RANK_CHART_PRINT_LAYOUTS = {
  landscape: {
    id: 'landscape',
    label: 'Landscape',
    candidateLabelWidth: 103,
    legendItemsPerRow: 4,
    pageMargin: '0.2in',
    paperLayouts: {
      letter: {
        candidatesPerPageBase: 13,
        graphHeightInches: 5.625,
        graphMargin: { top: 10, right: 75, bottom: 45, left: 117 },
        graphWidth: 950,
        pageSize: '11in 8.5in',
        sheetWidth: '10.6in',
      },
      a4: {
        // A4 landscape is wider but slightly shorter than Letter landscape.
        candidatesPerPageBase: 12,
        graphHeightInches: 5.4,
        graphMargin: { top: 10, right: 75, bottom: 45, left: 117 },
        graphWidth: 990,
        pageSize: '297mm 210mm',
        sheetWidth: '11.05in',
      },
    },
  },
  portrait: {
    id: 'portrait',
    label: 'Portrait',
    candidateLabelWidth: 145,
    legendItemsPerRow: 3,
    pageMargin: '0.35in',
    paperLayouts: {
      letter: {
        candidatesPerPageBase: 11,
        graphHeightInches: 7.3,
        graphMargin: { top: 10, right: 75, bottom: 45, left: 160 },
        graphWidth: 700,
        pageSize: '8.5in 11in',
        sheetWidth: '7.8in',
      },
      a4: {
        // A4 portrait is narrower but taller than Letter portrait.
        candidatesPerPageBase: 11,
        graphHeightInches: 7.9,
        graphMargin: { top: 10, right: 75, bottom: 45, left: 160 },
        graphWidth: 675,
        pageSize: '210mm 297mm',
        sheetWidth: '7.35in',
      },
    },
  },
};

export const getRankChartPrintLayout = (layoutId, paperId = 'letter') => {
  const layout = RANK_CHART_PRINT_LAYOUTS[layoutId] || RANK_CHART_PRINT_LAYOUTS.landscape;
  const paper = RANK_CHART_PRINT_PAPERS[paperId] || RANK_CHART_PRINT_PAPERS.letter;
  const paperLayout = layout.paperLayouts[paper.id];

  return {
    ...layout,
    ...paperLayout,
    paper,
  };
};

export const RANK_CHART_PRINT_LAYOUT_OPTIONS = Object.values(RANK_CHART_PRINT_LAYOUTS);
export const RANK_CHART_PRINT_PAPER_OPTIONS = Object.values(RANK_CHART_PRINT_PAPERS);

const PRINT_LEGEND_ROW_HEIGHT_INCHES = 0.375;
const COMPACT_BAR_LABEL_WEIGHT_LIMITS = {
  landscape: 8,
  portrait: 4,
};

export const getRankChartPrintBarLabelFontSize = (layoutId, weightCount = 0) => {
  const layout = getRankChartPrintLayout(layoutId);
  return weightCount > COMPACT_BAR_LABEL_WEIGHT_LIMITS[layout.id] ? 9 : 11;
};

export const getRankChartPrintCandidateLabelMaxLines = (layoutId, candidateCount = 0) => {
  const layout = getRankChartPrintLayout(layoutId);
  return layout.id === 'portrait' && candidateCount <= 6 ? Infinity : 2;
};

export const getRankChartPrintGraphHeight = (layoutId, weightCount = 0, paperId = 'letter') => {
  const printLayout = getRankChartPrintLayout(layoutId, paperId);
  const legendRows = Math.ceil(weightCount / printLayout.legendItemsPerRow);
  const extraLegendRows = Math.max(legendRows - 1, 0);
  return `${printLayout.graphHeightInches - extraLegendRows * PRINT_LEGEND_ROW_HEIGHT_INCHES}in`;
};
